import { AllPlans } from "contexts/Subscription";
import { Organization, Subscription } from "schemas/dashboard";
import { Plans } from "schemas/payments";

export const PRO_SALE_START = new Date(
  process.env.NODE_ENV === "production"
    ? "2026-04-28T04:00:00Z" // midnight EDT
    : "2026-04-23T04:00:00Z",
);
export const PRO_SALE_END = new Date("2026-05-06T04:00:00Z"); // midnight EDT
export const DISCOUNTED_PRO_PRICE = 29;

export const eligibleForProDiscount = (
  currentOrg: Organization | null,
  plans: AllPlans | null,
  subscription: Subscription | null,
) => {
  // Ensure we already toggle on the check on the BE to show this banner.
  if (plans?.[Plans.PRO]?.price !== DISCOUNTED_PRO_PRICE) {
    return false;
  }

  // Encourage users who are Free users, or on Pro monthly plan to upgrade to Pro discount.
  // April 29 to May 5
  if (currentOrg?.isVaUser) {
    return false;
  }
  if (
    currentOrg?.isProUser &&
    subscription?.subscription?.planName === Plans.PRO_YEARLY
  ) {
    return false;
  }

  const alreadyOnDiscountedPro =
    subscription?.subscription?.price &&
    subscription?.subscription?.price <= DISCOUNTED_PRO_PRICE;
  if (
    currentOrg?.isProUser &&
    subscription?.subscription?.planName === Plans.PRO &&
    alreadyOnDiscountedPro
  ) {
    return false;
  }
  if (currentOrg?.isAutopilotUser) {
    return false;
  }
  const now = new Date();

  return now >= PRO_SALE_START && now < PRO_SALE_END;
};
